const initialState = [];

export const participantsReducer = (state = initialState, action) => {
    if (action.type === 'SET_PARTICIPANTS') {
        return [...state, action.payload]
    } else if (action.type === 'UPDATE_PARTICIPANTS') {
        return state.map((item) => {
            if (item.idPeserta === action.payload.idPeserta) {
                return { ...item, ...action.payload }
            }
            return item
        })
    } else if (action.type === 'REMOVE_PARTICIPANTS') {
        return state.filter((item) => item.idPeserta !== action.payload.idPeserta);
    } else if (action.type === 'UNSET_PARTICIPANT_IN_PROGRAM') {
        return state.filter((item) => item.programId !== action.payload.programId);
    }
    return state
}